
import React, { useEffect, useState } from "react";
import { FaDownload, FaUpload } from "react-icons/fa";
import { months } from '../util/common';
import ApplicationService from "../services/axios.service";


const SalesSummaryMonthly = () => {
  const [year, setYear] = useState(new Date().getYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [availableYears, setAvailableYears] = useState([]);
  const service = new ApplicationService();

  const fetchYears = async () => {
    try {
      const response = await service.getSaleslabYear();
      const result = response.data;
      if (result.statusCode === 200) {
        const years = result.data;
        setAvailableYears(years);
        setYear(years.length > 0 ? years[0] : new Date().getFullYear());
      } else {
        console.error('Error fetching years:', result.message);
      }
    } catch (error) {
      console.error('Error fetching years:', error);
    }
  };

  useEffect(() => {
    fetchYears();
  }, []);

  const data = [
    {
      customer: "TGCS SP700",
      criteria: "FG",
      personInCharge: "PSI",
      modelName: "SMU-4000-777-1-900E BASE UNIT",
      partNumber: "003A01A432000",
      forecast_unitPrice: "$37",
      forecast_quantity: "$165",
      forecast_amount: "$123",
      actual_unitPrice: "$37",
      actual_quantity: "$165",
      actual_amount: "$123",
    },
    {
      customer: "TGCS SP700",
      criteria: "FG",
      personInCharge: "PSI",
      modelName: "SMU-4000-777-1-900E BASE UNIT",
      partNumber: "003A01A432000",
      forecast_unitPrice: "$37",
      forecast_quantity: "$165",
      forecast_amount: "$123",
      actual_unitPrice: "$37",
      actual_quantity: "$165",
      actual_amount: "$123",
    }, {
      customer: "TGCS SP700",
      criteria: "FG",
      personInCharge: "PSI",
      modelName: "SMU-4000-777-1-900E BASE UNIT",
      partNumber: "003A01A432000",
      forecast_unitPrice: "$37",
      forecast_quantity: "$165",
      forecast_amount: "$123",
      actual_unitPrice: "$37",
      actual_quantity: "$165",
      actual_amount: "$123",
    }, {
      customer: "TGCS SP700",
      criteria: "FG",
      personInCharge: "PSI",
      modelName: "SMU-4000-777-1-900E BASE UNIT",
      partNumber: "003A01A432000",
      forecast_unitPrice: "$37",
      forecast_quantity: "$165",
      forecast_amount: "$123",
      actual_unitPrice: "$37",
      actual_quantity: "$165",
      actual_amount: "$123",
    }, {
      customer: "TGCS SP700",
      criteria: "FG",
      personInCharge: "PSI",
      modelName: "SMU-4000-777-1-900E BASE UNIT",
      partNumber: "003A01A432000",
      forecast_unitPrice: "$37",
      forecast_quantity: "$165",
      forecast_amount: "$123",
      actual_unitPrice: "$37",
      actual_quantity: "$165",
      actual_amount: "$123",
    },
    {
      customer: "",
      criteria: "",
      personInCharge: "",
      modelName: "Daytona  S TTL",
      partNumber: "",
      forecast_unitPrice: "$187",
      forecast_quantity: "$456",
      forecast_amount: "$287",
      actual_unitPrice: "$187",
      actual_quantity: "$34",
      actual_amount: "$86",
    },
    {
      customer: "",
      criteria: "",
      personInCharge: "",
      modelName: "Others Total",
      partNumber: "",
      forecast_unitPrice: "$187",
      forecast_quantity: "$456",
      forecast_amount: "$287",
      actual_unitPrice: "$187",
      actual_quantity: "$34",
      actual_amount: "$86",
    },
    {
      customer: "",
      criteria: "",
      personInCharge: "",
      modelName: "Management challenge",
      partNumber: "",
      forecast_unitPrice: "$187",
      forecast_quantity: "$456",
      forecast_amount: "$287",
      actual_unitPrice: "$187",
      actual_quantity: "$34",
      actual_amount: "$86",
    },
    {
      customer: "",
      criteria: "",
      personInCharge: "",
      modelName: "Total",
      partNumber: "",
      forecast_unitPrice: "$187",
      forecast_quantity: "$456",
      forecast_amount: "$287",
      actual_unitPrice: "$187",
      actual_quantity: "$34",
      actual_amount: "$86",
    },
    {
      customer: "",
      criteria: "",
      personInCharge: "",
      modelName: "Total (Mgmt Challenge)",
      partNumber: "",
      forecast_unitPrice: "$187",
      forecast_quantity: "$456",
      forecast_amount: "$287",
      actual_unitPrice: "$187",
      actual_quantity: "$34",
      actual_amount: "$86",
    }
  ];

  return (
    <div className="p-4 bg-[#f9fafb]">
      {/* Filter Row */}
      <div className="flex gap-4 mb-4">
        <div className="w-1/4">
          <label className="block text-sm font-semibold text-gray-700 mb-1">Year</label>
          <select
            id="year"
            value={year}
            onChange={(e) => setYear(e.target.value)}
            className="w-full border border-gray-300 rounded px-2 py-1 h-10 cursor-pointer"
          >
            {availableYears.map((yr, idx) => (
              <option key={idx} value={yr}>
                {yr}
              </option>
            ))}
          </select>
        </div>
        <div className="w-1/3">
          <label className="block text-sm font-semibold text-gray-700 mb-1">Month</label>
          <select
            id="month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            className="w-full border border-gray-300 rounded px-2 py-1 h-10 cursor-pointer"
          >
            <option value="">Select Month</option>
            {months.map((m, index) => (
              <option key={index} value={m.value}>
                {m.label}
              </option>
            ))}
          </select>
        </div>
        <div className="w-1/4 flex items-end">
          <button className="bg-[#3D3D3D] text-white px-4 py-2 h-10 rounded-md w-full cursor-pointer">
            <span className='text-white'>Search</span>
          </button>
        </div>
        <div className='md:w-1/3'>

        </div>
      </div>
      <div className="flex py-4">
        <h3 className="text-lg font-semibold text-[#1D1D1D] mb-4"></h3>
        <div className="ml-auto flex gap-x-5">
          {/* Import Button with icon */}
          <button className="bg-[#287DD1] text-white px-6 rounded-md flex items-center gap-x-2">
            <FaUpload className="text-white" /> {/* Upload icon */}
            <span className="text-white">Import</span>
          </button>

          {/* Export Button with icon */}
          <button className="bg-[#107C41] text-white px-6 py-3 rounded-md flex items-center gap-x-2">
            <FaDownload className="text-white" /> {/* Download icon */}
            <span className="text-white">Export</span>
          </button>
        </div>
      </div>

      {/* Table Section */}
      <div className="bg-white  shadow-md overflow-x-auto">
        <table className="min-w-full table-auto border border-[#D5D5D5]">
          <thead className="bg-[#F7F8FF]">
            <tr>
              <th className="px-4 py-2 font-medium text-center border-r bg-[#EBEFFF] border-[#D5D5D5]" colSpan={5}>Sales Budget 2023A</th>
              <th className="px-4 py-2 font-medium text-center border-r bg-[#FDF1F1] border-[#D5D5D5]" colSpan={3}>Forecast (April)</th>
              <th className="px-4 py-2 font-medium text-center border-r bg-[#FDF1F1] border-[#D5D5D5]" colSpan={3} >Actual (April)</th>
            </tr>
            <tr>
              <th className="px-4 py-2 font-medium text-left whitespace-nowrap">Customer</th>
              <th className="px-4 py-2 font-medium text-left whitespace-nowrap">Criteria</th>
              <th className="px-4 py-2 font-medium text-left whitespace-nowrap">Person-in-charge</th>
              <th className="px-4 py-2 font-medium text-left whitespace-nowrap">Model Name</th>
              <th className="px-4 py-2 font-medium text-left whitespace-nowrap  border-r border-[#D5D5D5]" >Part Number</th>
              <th className="px-4 py-2 font-medium text-left whitespace-nowrap">Unit Price</th>
              <th className="px-4 py-2 font-medium text-left whitespace-nowrap">Quantity</th>
              <th className="px-4 py-2 font-medium text-left whitespace-nowrap  border-r border-[#D5D5D5]">Amount</th>
              <th className="px-4 py-2 font-medium text-left whitespace-nowrap">Unit Price</th>
              <th className="px-4 py-2 font-medium text-left whitespace-nowrap">Quantity</th>
              <th className="px-4 py-2 font-medium text-left whitespace-nowrap">Amount</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index} className="hover:bg-[F7F8FF]  border-b border-[#D5D5D5]">
                <td className="px-4 py-3">{row.customer}</td>
                <td className="px-4 py-3">{row.criteria}</td>
                <td className="px-4 py-3">{row.personInCharge}</td>
                <td className="px-4 py-3">{row.modelName}</td>
                <td className="px-4 py-3  border-r border-[#D5D5D5]">{row.partNumber}</td>
                <td className="px-4 py-3">{row.forecast_unitPrice}</td>
                <td className="px-4 py-3">{row.forecast_quantity}</td>
                <td className="px-4 py-3  border-r border-[#D5D5D5]">{row.forecast_amount}</td>
                <td className="px-4 py-3">{row.actual_unitPrice}</td>
                <td className="px-4 py-3">{row.actual_quantity}</td>
                <td className="px-4 py-3">{row.actual_amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SalesSummaryMonthly;
